import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "relative inline-block text-left" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "text-sm text-black border-t-0 max-h-64 overflow-y-auto" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "ml-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "flex items-center p-1 rounded-md text-primary-font text-sm transition select-none cursor-pointer",
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)), ["stop"]))
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(_ctx.colorflagName())
      }, _toDisplayString(_ctx.currentLocale?.name), 3),
      (_ctx.currentLocale)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.currentLocale.pic,
            class: "w-5 h-5 object-cover ml-1"
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true)
    ]),
    (_ctx.open)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([
        'absolute right-0 w-42 origin-top-right bg-white border border-primary-font/30 rounded-lg shadow-xl overflow-hidden z-50',
        _ctx.direction === 'up' ? 'bottom-full mb-2' : 'top-full mt-2'
      ])
        }, [
          _createElementVNode("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localeList, (locale, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: "flex items-center px-2 py-2 hover:bg-primary cursor-pointer",
                onClick: ($event: any) => (_ctx.selectLocale(locale))
              }, [
                _createElementVNode("img", {
                  src: locale.pic,
                  class: "w-5 h-5 object-cover"
                }, null, 8, _hoisted_5),
                _createElementVNode("span", _hoisted_6, _toDisplayString(locale.name), 1)
              ], 8, _hoisted_4))
            }), 128))
          ])
        ], 2))
      : _createCommentVNode("", true)
  ]))
}